module.exports = __webpack_public_path__ + "static/media/vegitables_9.36a429fb.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_9.csv
// module id = 669
// module chunks = 0